import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import { safeOnComplete } from "../../utils/safeOnComplete";
import * as actions from "../../api/actions/pos";
import { controller, endpoints } from "../../api/actions/api";
import { useEffect, useState } from "react";  // ADD useState and useEffect for company name
import { formatCurrency } from "../../hooks/Currency";

const PrintReceipt = ({ data, _store, _authUser, _get  }) => {
  const { t, i18n } = useTranslation();
  const [companyName, setCompanyName] = useState(""); // ADD

  // ✅ ADD HERE (inside component)
  // const isSplit =
  //   data?.payments?.length > 1 ||
  //   (data?.cashAmount > 0 && data?.cardAmount > 0);


const paymentLabels = {
  1: t("cash"),
  2: t("card"),
  3: t("stripe"),
  4: t("check"),
  5: t("payLater"),
  6: t("split"),
  7: t("other"),
};

const paymentLabel = paymentLabels[data?.payType] || t("other");  


const storeTimeZone =
  _store?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;

const receiptLocale =
  i18n.language === "fr"
    ? "fr-FR"
    : i18n.language === "es"
    ? "es-ES"
    : "en-US";

const sellDate = data?.sellDate
  ? new Date(data.sellDate + "Z").toLocaleString(receiptLocale, {
      timeZone: storeTimeZone,
    })
  : "";

const amountStyle = {
  minWidth: "80px",
  textAlign: "right",
};

const showChange =
  data.cashAmount > 0 ||
  (data.cashAmount > 0 && data.cardAmount > 0);

  //----------------------------------------

   // ADD: fetch company name once
    useEffect(() => {
      if (!_get || !_authUser?.id) return;

      const onComplete = safeOnComplete(
        (res) => {
          const name =
            res?.result?.companyName ||
            res?.result?.name;

          if (name) {
            setCompanyName(name);
          }
        },
        (err) => {
          console.error("Company fetch failed:", err);
        }
      );

    //

      _get(
        endpoints.Companies + controller.GetCompanyName,
        actions.ActionType.Data,
        onComplete
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_authUser?.id]);

 
  return (
      <div 
        style={{
        width: "80mm",
        padding: "5px",
        fontFamily: "monospace",
        fontSize: "12px"
      }}>
      <div
        style={{
          justifyContent: "center",
          display: "grid",
          alignItem: "center",
          textAlign: "center",
          lineHeight: "1.2",
          marginBottom: "5px",
        }}
      >
        {companyName && (
          <div style={{ fontSize: "18px", fontWeight: "700",  textTransform: "uppercase" }}
          >
            {companyName}
          </div>
        )}

          <div style={{ fontSize: "14px", fontWeight: "600" }}>
            {_store.storeName}
          </div>

        <div> {_store.address}</div>

        <div> {_store.phone}</div>
      </div>

      <div
        style={{
          marginTop: "5px",
          marginBottom: "5px",
        }}
      >
      <div>
        {t("servedBy")}: {_authUser?.firstName || "Mr X."}
      </div>

      <div>
        {t("invoiceNo")}: {data.id}
      </div>

      <div>
        {t("date")}: {sellDate}
      </div>

      <div>
        {t("paymentType")}: {paymentLabel}
      </div>

      <div>
        {t("customer")}:{" "}
        {data.customer?.customerName || t("walkInCustomer")}
      </div>

      </div>

      {/* Product List */}
      <div style={{ marginTop: "20px" }}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            fontWeight: "500",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
        <span style={{ width: "40%" }}>{t("itemName")}</span>
        <span style={{ width: "10%", textAlign: "center" }}>{t("qty")}</span>
        <span style={{ width: "25%" }}>{t("price")}</span>
        <span style={{ width: "25%", textAlign: "right" }}>
          {t("total")}
        </span>

        </div>

        {/* Body */}
        {data.sellItems &&
          data.sellItems.map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                fontSize: "12px",
                padding: "5px 5px 5px 0px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <span style={{ width: "60%" }}>
                {item.itemType === 1 ? item.product.name : t("discount")}
              </span>
              <span style={{ width: "15%", textAlign: "center" }}>
                {item.qty}
              </span>
              <span style={{ width: "25%" }}>
                {formatCurrency(item.price, _store)}
              </span>
              <span style={{ width: "25%", textAlign: "right" }}>
                {formatCurrency(item.qty * item.price, _store)}
              </span>
              
            </div>
          ))}
      </div>
      <div style={{ borderBottom: "3px dotted var(--grayLight-color)" }} />
      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            fontWeight: "500",
            fontSize: "12px",
            marginTop: "10px"
          }}
        >
        </div>    
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "3px 0px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <span>{t("subtotal")}:</span>
            <span style={amountStyle}>
              {formatCurrency(data.subtotal, _store)}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "3px 0px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <span>
              {t("tax")}({_store.tax}%):
            </span>
            <span style={amountStyle}>
              {formatCurrency(data.tax, _store)}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "700",
              fontSize: "18px",
              borderTop: "2px solid black",
              borderBottom: "2px solid black",
              padding: "6px 0",
              margin: "6px 0",
            }}
          >
            <span>{t("total").toUpperCase()}</span>
            <span style={amountStyle}>
              {formatCurrency(Number(data.subtotal) + Number(data.tax), _store)}
            </span>
          </div>
          {/* try using data.paymentType instead of data.cashAmount and data.cardAmount
           if data.paymentType is 1 then it's cash, if it's 2 then it's card, if it's 3 then it's split
           this way we can avoid showing cash amount and card amount when it's not needed
           also we can show the payment method instead of showing cash amount and card amount*/}
          
          {/* end of try*/}

          {data.cashAmount > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "3px 0px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <span>{t("cash")}:</span>
              <span style={amountStyle}>
                {formatCurrency(data.cashAmount, _store)}
              </span>
            </div>
          )}

          {Number(data.customerCreditUsed) > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "3px 0px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <span>{t("customerCreditUsed")}:</span>
              <span style={amountStyle}>
                {formatCurrency(data.customerCreditUsed, _store)}
              </span>
            </div>
          )}

          {data.cardAmount > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "3px 0px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <span>{t("card")}:</span>
              <span style={amountStyle}>
                {formatCurrency(data.cardAmount, _store)}
              </span>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "3px 0px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <span>{t("paymentReceived")}:</span>
            <span style={amountStyle}>
              {formatCurrency(data.received, _store)}
            </span>
          </div>
          {showChange && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "3px 0px",
            }}
          >
            <span>{t("change")}:</span>
            <span style={amountStyle}>
              {formatCurrency(data.change, _store)}
            </span>
          </div>
          )}

        </div>
        <div
        style={{
          textAlign:"center",
          marginTop:"20px",
          borderTop:"1px dashed black",
          paddingTop:"10px"
        }}
      >
        <div>{t("thankYouForShopping")}</div>
        <div>{t("pleaseComeAgain")}</div>
        {<div style={{marginTop:"10px"}}>
         {/* {www.{companyName.replace(/\s+/g, "")}.com} */}
        </div>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  _store: state.pos.defStore,
  _authUser: state.pos.authUser,
});

const mapActionToProps = {
  _get: actions.get,
};

export default connect(mapStateToProps, mapActionToProps)(PrintReceipt);
